import application from 'application/application';

application

	.factory ('HttpRequestTimeoutInterceptor', ['HttpPendingRequestsService', (HttpPendingRequestsService) => ({

		request: (config) => {

			config = config || {};

			if (config.timeout === undefined && !config.noCancelOnRouteChange) {
				config.timeout = HttpPendingRequestsService.newTimeout();
			}

			return config;

		}

	})]);